// extracted by mini-css-extract-plugin
export var dark = "spinner--dark--d3a03";
export var fadeIn = "spinner--fadeIn--cf91c";
export var large = "spinner--large--c7a4f";
export var light = "spinner--light--faa7a";
export var medium = "spinner--medium--6a9a5";
export var small = "spinner--small--2f031";
export var spin = "spinner--spin--c5b24";
export var spinner = "spinner--spinner--d9dee";
export var staticFallbackIcon = "spinner--static-fallback-icon--11dac";